import { usePlanFeatureGate } from './use-plan-feature-gate';
import { Features } from '../constants/features';

/** @typedef {import('./use-plan-feature-gate').FeatureAccessValueType} FeatureAccessValueType */
/** @typedef {import('../prop-types/intl-types').MessageDescriptor} MessageDescriptor */

/**
 * Freemium Rate Shopper is the more basic RateShopper feature
 * that allows users to use the ShipStation provided defaults.
 * The useAutomatedRateShopperFeatureGate controls the more advanced RateShopper feature.
 * @param {FeatureAccessValueType} defaultFeatureAccessValue
 * @returns {{ isFeatureEnabled: boolean, disabledMessage?: MessageDescriptor}}
 */
export const useFreemiumRateShopperFeatureGate = (defaultFeatureAccessValue) =>
  usePlanFeatureGate(Features.FreemiumRateShopper, defaultFeatureAccessValue);
